<template>
  <div>
    <v-card>
      <v-card-title style="background-color: #e6e6e6;" class="justify-center">
        <v-icon left>menu_book</v-icon>
        Cadernos
      </v-card-title>

      <v-card-text>

        <v-row class="mt-5">

          <v-col cols='2'>
            <v-select
                @change="filtrar()"
                v-model='filtro.anoSelecionado'
                :items='filtro.anos'
                label='Ano'
                no-data-text='Nenhum ano escolar encontrado'
                dense
                outlined
            ></v-select>
          </v-col>

          <v-col cols='2'>
            <v-select
                @change="filtrar()"
                v-model='filtro.disciplinaSelecionada'
                :items='filtro.disciplinas'
                label='Disciplina'
                no-data-text='Nenhuma disciplina encontrada'
                dense
                outlined
            ></v-select>
          </v-col>

          <v-col cols="7">
            <v-text-field
                label="Pesquisar"
                v-model="pesquisa"
                dense
                outlined
                class="ml-5 mr-5"/>
          </v-col>

          <v-col cols="1" style="margin-top: -10px;">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn @click="novoCaderno" v-on="on" dark fab color="blue" class="mr-5">
                  <v-icon>add</v-icon>
                </v-btn>
              </template>
              <span>Cadastrar</span>
            </v-tooltip>
          </v-col>


        </v-row>

        <v-data-table
            no-results-text="Nenhum caderno encontrado!"
            no-data-text="Nenhum caderno cadastrado!"
            loading-text="Carregando..."
            :footer-props="footerProps"
            :headers="cadernoHeaders"
            :items="cadernos"
            :search="pesquisa"
            :loading="carregandoCadernos">

          <template v-slot:item.action="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon color="blue" @click="editarCaderno(item)"> edit</v-icon>
                </v-btn>
              </template>
              <span>Editar</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon color="red" @click="deletarCaderno(item)">delete</v-icon>
                </v-btn>
              </template>
              <span>Deletar</span>
            </v-tooltip>

          </template>

        </v-data-table>
      </v-card-text>

    </v-card>

    <!-- CADERNO DIALOG -->
    <v-dialog
        v-model="cadernoDialog"
        width="1000"
        :fullscreen="true"
    >
      <v-card>
        <v-card-title style="background-color: #e6e6e6;" class="justify-center">
          <v-icon left>menu_book</v-icon>
          {{ cadernoDialogTitle }}
        </v-card-title>

        <v-card-text>
          <v-row>

            <v-col cols="2">
              <v-select
                  label="Ano"
                  v-model="cadernoAtual.ano"
                  :items="anos"
                  menu-props="auto"
              ></v-select>
            </v-col>

            <v-col cols="5">
              <v-text-field label="Descrição" v-model="cadernoAtual.descricao"/>
            </v-col>

            <v-col cols="5">
              <v-select
                  label="Disciplina"
                  :items="disciplinas"
                  item-text="descricao"
                  return-object
                  v-model="cadernoAtual.disciplina"
              >
              </v-select>
            </v-col>


          </v-row>

          <v-row v-if="editandoCaderno">
            <v-card-title class="justify-center">
              Seleção de Habilidades
            </v-card-title>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn @click="novaHabilidade" v-on="on" small dark fab color="blue" class="mr-5 mt-3">
                  <v-icon>add</v-icon>
                </v-btn>
              </template>
              <span>Cadastrar Habilidade</span>
            </v-tooltip>
          </v-row>

          <v-divider/>

          <v-data-table v-if="editandoCaderno"
                        :footer-props="footerProps"
                        :headers="perguntasHeader"
                        :items="habilidades"
                        :loading="carregandoHabilidades"
                        :options.sync="habilidadeOptions"
                        :page.sync="habilidadePage"
                        no-results-text="Nenhuma habilidade encontrada!"
                        no-data-text="Nenhuma habilidade cadastrada!"
          >
            <template v-slot:item.action="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on">
                    <v-icon color="blue" @click="editarHabilidade(item)"> edit</v-icon>
                  </v-btn>
                </template>
                <span>Editar</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on">
                    <v-icon color="red" @click="deletarHabilidade(item)">delete</v-icon>
                  </v-btn>
                </template>
                <span>Deletar</span>
              </v-tooltip>
            </template>

          </v-data-table>
        </v-card-text>

        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn :loading="salvando" color="grey" dark
                 @click="cancelarCaderno()">
            CANCELAR
          </v-btn>
          <v-btn :loading="salvando" :disabled="!(disableSalvarCaderno())" color="success"
                 @click="editandoCaderno ? atualizarCaderno() : salvarCaderno()">
            SALVAR
          </v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>
    <!-- CADERNO DIALOG -->

    <!-- HABILIDADE DIALOG -->
    <v-dialog
        v-model="habilidadeDialog"
        width="750"
    >
      <v-card>
        <v-card-title style="background-color: #e6e6e6;" class="justify-center">
          <v-icon left>menu_book</v-icon>
          {{ habilidadeDialogTitle }}
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col cols="6">
              <v-text-field
                  id="descricao"
                  label="Descricao"
                  v-model="habilidade.descricao"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                  id="tema"
                  label="Tema"
                  v-model="habilidade.tema"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <v-text-field
                  id="genero"
                  label="Gênero"
                  v-model="habilidade.genero"
              ></v-text-field>
            </v-col>

            <v-col cols="4">
              <v-text-field
                  id="numero"
                  label="Numero"
                  type="number"
                  v-model="habilidade.numero"
              ></v-text-field>
            </v-col>

            <v-col cols="4">
              <v-text-field
                  id="nivel"
                  label="Nível"
                  type="number"
                  v-model="habilidade.nivel"
              ></v-text-field>
            </v-col>


          </v-row>

          <v-row>
            <v-col cols="3">
              <v-text-field
                  id="pesoa"
                  type="number"
                  label="Peso A"
                  v-model="habilidade.pesoItemA"
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field
                  id="pesob"
                  type="number"
                  label="Peso B"
                  v-model="habilidade.pesoItemB"
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field
                  id="pesoc"
                  type="number"
                  label="Peso C"
                  v-model="habilidade.pesoItemC"
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field
                  id="pedod"
                  type="number"
                  label="Peso D"
                  v-model="habilidade.pesoItemD"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn :loading="salvandoHabilidade" color="grey" dark
                 @click="habilidadeDialog = false">
            CANCELAR
          </v-btn>
          <v-btn :loading="salvandoHabilidade"
                 :disabled="!(habilidade.descricao && habilidade.numero && habilidade.nivel && habilidade.genero && habilidade.tema)"
                 color="success"
                 @click="editandoHabilidade ? atualizarHabilidade() : salvarHabilidade()">
            SALVAR
          </v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>
    <!-- HABILIDADE DIALOG -->

    <!-- SNACKBAR DIALOG -->
    <v-snackbar
        style="z-index: 1000;"
        absolute
        v-model="snackbar.active"
        :color="snackbar.color"
        :top="true"
    >
      {{ snackbar.message }}
      <v-btn dark text @click="snackbar.active = false">
        Fechar
      </v-btn>
    </v-snackbar>
    <!-- SNACKBAR DIALOG -->

    <!-- CONFIRM DIALOG -->
    <v-dialog v-model="confirmDialog" min-width="290" max-width="500" persistent>
      <v-card>
        <v-card-title class="headline">{{ menssagem }}</v-card-title>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn :disabled="confirmando" color="error" text @click="confirmDialog=false">CANCELAR</v-btn>
          <v-btn :loading="confirmando" color="green darken-1" text @click="confirmFunction">ACEITAR</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- CONFIRM DIALOG -->

    <ProvaPicker :show="showProvaPicker"
                 :id="cadernoUpload"
                 :arquivo-id="arquivoProvaId"
                 :arquivo-name="arquivoName"
                 :download-finished="downloadFinished"
                 :confirmar-delete="confirmarDeleteAquivo"
                 :fechar="fecharProvaPicker"
                 :prova-name="cadernoName"
                 :arquivo-list="arquivoList"
    />

  </div>
</template>

<script>

import DisciplinaService from '../../service/DisciplinaService';
import CadernoService from '../../service/CadernoService';
import HabilidadeService from '../../service/HabilidadeService'
import ProvaPicker from "@/views/Cadernos/ProvaPicker";
import _ from "lodash";

export default {
  components: {ProvaPicker},
  data() {
    return {
      anos: ["1°", "2°", "3°", "4°", "5°", "6°", "7°", "8°", "9°"],
      showProvaPicker: false,
      cadernoUpload: 0,
      arquivoProvaId: null,
      arquivoName: "",
      cadernoName: "",
      arquivoList: [],
      footerProps: {
        itemsPerPageText: "Itens por página:",
        itemsPerPageOptions: [5, 10, 20, 50]
      },
      perguntasHeader: [
        {
          text: "Descricao",
          value: "descricao",
          align: "center"
        },
        {
          text: "Numero",
          value: "numero",
          align: "center"
        },
        {
          text: "Genero",
          value: "genero",
          align: "center"
        },
        {
          text: "Tema",
          value: "tema",
          align: "center"
        },
        {
          text: "Nível",
          value: "nivel",
          align: "center"
        },
        {
          text: "Peso A",
          value: "pesoItemA",
          align: "center"
        },
        {
          text: "Peso B",
          value: "pesoItemB",
          align: "center"
        },
        {
          text: "Peso C",
          value: "pesoItemC",
          align: "center"
        },
        {
          text: "Peso D",
          value: "pesoItemD",
          align: "center"
        },
        {
          text: "Ação",
          value: "action",
          align: "center",
          sortable: false
        },
      ],
      cadernoHeaders: [
        {
          text: "ID",
          value: "id",
          align: "center"
        },
        {
          text: "Ano",
          value: "ano",
          align: "center"
        },
        {
          text: "Descrição",
          value: "descricao",
          align: "center"
        },
        {
          text: "Disciplina",
          value: "disciplina",
          align: "center"
        },
        {
          text: "Ação",
          value: "action",
          align: "center",
          sortable: false
        },
      ],
      cadernos: [],
      todosCadernos: [],
      habilidades: [],
      pesquisa: "",
      carregandoCadernos: false,
      carregandoHabilidades: false,
      disciplinas: [],
      disciplinaSelecionada: null,

      snackbar: {
        message: "",
        color: "",
        active: ""
      },

      cadernoAtual: {
        id: null,
        ano: null,
        disciplina: null,
        descricao: null
      },
      habilidade: {
        descricao: null,
        numero: 0,
        caderno: null,
        genero: null,
        tema: null,
        nivel: 0,
        pesoItemA: 0,
        pesoItemB: 0,
        pesoItemC: 0,
        pesoItemD: 0
      },
      cadernoDialog: false,
      editandoCaderno: false,
      cadernoDialogTitle: "Novo caderno",
      habilidadeDialogTitle: "Seleção de Habilidade",
      editandoHabilidade: false,
      salvando: false,
      salvandoHabilidade: false,
      habilidadePage: 1,
      habilidadeOptions: {},

      confirmando: false,
      confirmDialog: false,
      habilidadeDialog: false,
      confirmFunction: null,
      cadernoParaDeletar: null,
      habilidadeParaDeletar: null,
      menssagem: "",

      filtro: {
        anos: [],
        anoSelecionado: 'Todos',
        disciplinas: [],
        disciplinaSelecionada: 'Todas'
      },
    }
  },

  methods: {

    filtrar() {

      let self = this;

      this.cadernos = JSON.parse(JSON.stringify(this.todosCadernos));

      this.cadernos = _.filter(this.cadernos, function (caderno) {

        if (self.filtro.disciplinaSelecionada !== 'Todas' && !caderno.disciplina.includes(self.filtro.disciplinaSelecionada))
          return false;

        return !(self.filtro.anoSelecionado !== 'Todos' && !caderno.ano.includes(self.filtro.anoSelecionado))

      });
    },

    setFiltros() {

      let self = this;

      this.filtro.anos = ['1°', '2°', '3°', '4°', '5°', '6°', '7°', '8°', '9°', '10°']
      this.filtro.anos = _.filter(this.filtro.anos, function (ano) {
        for (let i = 0; i < self.cadernos.length; i++)
          if (self.cadernos[i].ano.includes(ano))
            return true;
        return false;
      })
      this.filtro.anos.unshift('Todos')

      this.filtro.disciplinas = _.map(self.cadernos, 'disciplina')
      this.filtro.disciplinas.unshift('Todas')
    },

    disableSalvarCaderno() {
      return this.cadernoAtual.descricao && this.cadernoAtual.disciplina && this.cadernoAtual.ano;
    },

    novoCaderno() {
      this.reset();
      this.cadernoDialogTitle = "Novo caderno";
      this.cadernoDialog = true;
      this.editandoCaderno = false;
    },

    novaHabilidade() {
      this.resetHabilidade();
      this.habilidadeDialogTitle = "Seleção de Habilidade";
      this.habilidadeDialog = true;
      this.editandoHabilidade = false;
    },

    salvarHabilidade() {
      this.habilidade.caderno = this.cadernoAtual.id;
      this.salvandoHabilidade = true;

      HabilidadeService.salvarhabilidade(this.habilidade)
          .then(() => {
            this.snackbar.color = "green";
            this.snackbar.message = "Habilidade salva com sucesso!";
            this.snackbar.active = true;
            this.buscarHabilidades();
            this.resetHabilidade();
          })
          .catch(() => {
            this.snackbar.color = "red";
            this.snackbar.message = "Erro ao salvar habilidade!";
            this.snackbar.active = true;
          })
          .finally(() => {
            this.salvandoHabilidade = false;
          })
    },

    atualizarHabilidade() {

      this.salvandoHabilidade = true;
      HabilidadeService.atualizarHabilidade(this.habilidade)
          .then(() => {
            this.snackbar.color = "green";
            this.snackbar.message = "Habilidade atualizada com sucesso!";
            this.snackbar.active = true;
            this.buscarHabilidades();
            this.resetHabilidade();
          })
          .catch(() => {
            this.snackbar.color = "red";
            this.snackbar.message = "Erro ao atualizar habilidade!";
            this.snackbar.active = true;
          })
          .finally(() => {
            this.salvandoHabilidade = false;
          })
    },

    editarHabilidade(habilidade) {

      this.editandoHabilidade = true;

      HabilidadeService.buscarHabilidade(habilidade.id)
          .then(({data}) => {
            this.habilidade = data;
            this.habilidadeDialogTitle = "Seleção de Habilidade";
            this.habilidadeDialog = true;
          })
          .catch(() => {
            this.snackbar.color = "red";
            this.snackbar.message = "Erro ao carregar caderno!";
            this.snackbar.active = true;
          })
    },

    salvarCaderno() {

      this.salvando = true;


      CadernoService.salvarCaderno(this.cadernoAtual)
          .then(() => {
            this.snackbar.color = "green";
            this.snackbar.message = "Caderno atualizado com sucesso!";
            this.snackbar.active = true;
            this.buscarCadernos();
            this.reset();
          })
          .catch(() => {
            this.snackbar.color = "red";
            this.snackbar.message = "Erro ao carregar caderno!";
            this.snackbar.active = true;
          })
          .finally(() => {
            this.salvando = false;
          })
    },

    atualizarCaderno() {

      this.salvando = true;
      CadernoService.atualizarCaderno(this.cadernoAtual)
          .then(() => {
            this.snackbar.color = "green";
            this.snackbar.message = "Caderno atualizado com sucesso!";
            this.snackbar.active = true;
            this.buscarCadernos();
            this.reset();
          })
          .catch(() => {
            this.snackbar.color = "red";
            this.snackbar.message = "Erro ao carregar caderno!";
            this.snackbar.active = true;
          })
          .finally(() => {
            this.salvando = false;
          })
    },

    editarCaderno(caderno) {

      this.editandoCaderno = true;

      CadernoService.buscarCaderno(caderno.id)
          .then(({data}) => {
            this.cadernoAtual = data;
            this.cadernoDialogTitle = "Editando caderno";
            this.cadernoDialog = true;
            this.buscarHabilidades();
          })
          .catch(() => {
            this.snackbar.color = "red";
            this.snackbar.message = "Erro ao carregar caderno!";
            this.snackbar.active = true;
          })
    },

    cancelarCaderno() {
      this.reset();
    },

    reset() {
      this.habilidadeOptions.page = 1;
      this.habilidadePage = 1;
      this.cadernoAtual.ano = null;
      this.cadernoAtual.id = null;
      this.cadernoAtual.descricao = null;
      this.cadernoAtual.disciplina = null;
      this.cadernoDialog = false;
    },

    resetHabilidade() {
      this.habilidade = {
        descricao: null,
        caderno: null,
        genero: null,
        tema: null,
        numero: 0,
        nivel: 0,
        pesoItemA: 0,
        pesoItemB: 0,
        pesoItemC: 0,
        pesoItemD: 0
      };
      this.habilidadeDialog = false;
    },

    deletarCaderno(caderno) {
      this.menssagem = `Deseja deletar o caderno ${caderno.descricao}:`;
      this.confirmDialog = true;
      this.confirmFunction = this.confirmarDeletarCaderno;
      this.cadernoParaDeletar = caderno.id;
    },

    deletarHabilidade(habilidade) {
      this.menssagem = `Deseja deletar a habilidade ${habilidade.descricao}:`;
      this.confirmDialog = true;
      this.confirmFunction = this.confirmarDeletarHabilidade;
      this.habilidadeParaDeletar = habilidade.id;
    },

    confirmarDeletarCaderno() {
      this.confirmando = true;
      CadernoService.deletarCaderno(this.cadernoParaDeletar)
          .then(() => {
            this.snackbar.color = "green";
            this.snackbar.message = "Caderno deletada com sucesso!";
            this.snackbar.active = true;
            this.buscarCadernos();
          })
          .catch((e) => {
            console.error(e)
            this.snackbar.color = "red";
            this.snackbar.message = "Erro ao deletar caderno!";
            this.snackbar.active = true;
          })
          .finally(() => {
            this.confirmDialog = false;
            this.confirmando = false;
          })
    },

    confirmarDeletarHabilidade() {
      this.confirmando = true;
      HabilidadeService.deletarHabilidade(this.habilidadeParaDeletar)
          .then(() => {
            this.snackbar.color = "green";
            this.snackbar.message = "Habilidade deletado com sucesso!";
            this.snackbar.active = true;
            this.buscarHabilidades();
          })
          .catch((e) => {
            console.error(e)
            this.snackbar.color = "red";
            this.snackbar.message = "Erro ao deletar habilidade!";
            this.snackbar.active = true;
          })
          .finally(() => {
            this.confirmDialog = false;
            this.confirmando = false;
          })
    },

    buscarDisciplinas() {
      DisciplinaService.buscarListaDeDisciplinas()
          .then(({data}) => {
            this.disciplinas = data;
          })
    },

    buscarCadernos() {
      this.carregandoCadernos = true;
      CadernoService.buscarListaDeCadernos()
          .then(({data}) => {
            this.cadernos = data;
            this.todosCadernos = JSON.parse(JSON.stringify(this.cadernos));
            this.setFiltros();
          })
          .catch(() => {
            this.snackbar.color = "red";
            this.snackbar.message = "Erro ao carregar cadernos!";
            this.snackbar.active = true;
          })
          .finally(() => {
            this.carregandoCadernos = false;
          })
    },

    buscarHabilidades() {
      this.carregandoHabilidades = true;
      HabilidadeService.buscarListaDeHabilidades(this.cadernoAtual.id)
          .then(({data}) => {
            this.habilidades = data;
          })
          .catch(() => {
            this.snackbar.color = "red";
            this.snackbar.message = "Erro ao carregar cadernos!";
            this.snackbar.active = true;
          })
          .finally(() => {
            this.carregandoHabilidades = false;
          })
    },
    provaExtra(item) {
      this.arquivoList = item.arquivos;
      this.cadernoName = item.descricao;
      this.arquivoName = item.arquivoName;
      this.arquivoProvaId = item.arquivoProvaId;
      this.cadernoUpload = item.id;
      this.showProvaPicker = true
    },

    getProvaIconColor(item) {
      if (item.arquivoProvaId) {
        return 'orange'
      } else {
        return 'grey'
      }
    },

    downloadFinished(cadernoId, arquivo) {
      this.cadernos.forEach(c => {
        if (c.id == cadernoId) {
          c.arquivos.push(arquivo);
          this.arquivoList = c.arquivos;
        }
      });
    },

    confirmarDeleteAquivo(cadernoId, arquivo) {
      this.cadernos.forEach(c => {
        if (c.id == cadernoId) {
          c.arquivos = c.arquivos.filter(a => {
            return a.cdArquivo != arquivo.cdArquivo
          })
          this.arquivoList = c.arquivos;
        }
      });
      this.arquivoName = null;
      this.arquivoProvaId = null;
    },

    fecharProvaPicker() {
      this.showProvaPicker = false;
    },


  },

  created() {
    this.buscarDisciplinas();
    this.buscarCadernos();
  }
}
</script>

<style scoped>

</style>
